import React, { useState, useEffect } from 'react';
import axios from 'axios'
import './ScanResult.css';
import 'react-circular-progressbar/dist/styles.css';
import loader from '../images/scanning-loader.gif';
import Progress from './Progress';
import StatusPanel from './StatusPanel';
import DetailsPanel from './DetailsPanel';
import AnalyzedFaces from './AnalyzedFaces';
import VideoModal from './VideoModal';
/* import VideoCollectionModal from './VideoCollectionModal'; */
import utils, { statuses } from './Utils';
import ForensicVideoModal from './ForensicVideoModal';
import Footer from './Footer';
import Scanner_top from './Scanner_top';


const PageLoader = () => {
  return (
    <div id="wrapper" style={{ zIndex: 10000 }}>
      <section className="page-loader">
        <div className="container">
          <div className="row">
            <img
              className="img-responsive center-block"
              src={loader}
              alt="loader"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

const ScanResult = ({ reportID, anlystToken }) => {
  console.log("token:" + anlystToken);

  const [report, setReport] = useState(null);
  const [info, setInfo] = useState(null);
  const [videoModal, setVideoModal] = useState({ url: '', faces: false });
  const [forensicVideoModal, setForensicVideoModal] = useState({ url: '' });
  /* const [videoCollectionModal, setVideoCollectionModal] = useState(null); */
  const [status, setStatus] = useState(statuses.LOADING);
  const [frameData, setFrameData] = useState({
    frames: null,
    metadata: {}
  })
  const [myClass, setmyClass] = useState('');
  const [btnText, setbtnText] = useState('');
  const handleShowScanner = () => {
    setmyClass(myClass === "" ? "Showclass" : "")
    setbtnText(btnText === "" ? "Show" : "")
  }


  // askıda kalan request sayımızı consoleda görelim
  var pendingCalls = 0;

  axios.interceptors.request.use(function (config) {
    pendingCalls++;
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  axios.interceptors.response.use(function (response) {
    pendingCalls--;
    console.log("-- pending", pendingCalls);

    if (pendingCalls == 0) {
    }
    return response;
  }, function (error) {
    pendingCalls--;
    if (pendingCalls == 0) {
    }
    return Promise.reject(error);
  });

  var anlystTokenOK = false;

  useEffect(() => {
    if (!reportID) {
      setStatus(statuses.NOTFOUND);
      return;
    }

    if (!report?.completed) {
      setTimeout(() => {
        utils.getReport(
          reportID,
          (rep) => {
            setReport(rep);
            setStatus(utils.getStatusByReport(rep, 50, 51, 79, 80));
          },
          () => {
            setStatus(statuses.NOTFOUND);
          }
        );
      }, 2000);
      return;
    }

    if (report?.completed) {
      utils.getInfo(
        report?.['video-id'],
        (rep) => setInfo(rep),
        () => { }
      );
      if (info != null) {
        if (info?.metadata?.threshold != undefined) {
          setStatus(utils.getStatusByReport(report,
            info?.metadata?.threshold?.green[1],
            info?.metadata?.threshold?.yellow[0],
            info?.metadata?.threshold?.yellow[1],
            info?.metadata?.threshold?.red[0]))
        }
      }

    }
  
    utils.getFrames(reportID, setFrameData)

  }, [reportID, report]);

  return (
    <>
      {status === statuses.NOTFOUND ? (
        (window.location.href = '/404')
      ) : status === statuses.LOADING ? (
        <PageLoader />
      ) : (
        <section>
          <div className="container">
            <div id="scnDiv" className={myClass}>
              <Scanner_top />

            </div>
            <div className="row m-t-30 pd-30">
              <div className="col-xs-offset-0 col-xs-12 col-sm-offset-1  col-sm-10 col-md-offset-1 col-md-10 m-b-10">
                <StatusPanel
                  report={report}
                  status={status}
                  threshold={info?.metadata?.threshold}
                  btnText={btnText}
                  handleShowScanner={handleShowScanner.bind(this)}
                />
              </div>
            </div>
            <div className="row flex">
              <div className="col-xs-offset-0 col-xs-12 col-sm-offset-1 col-sm-10 col-md-10 p-b-30 flex">
                {
                   anlystToken == "analyst=69a12fa8-cfaa-470d-9bcb-68036bf3cc6b" ?
                      anlystTokenOK = true: anlystTokenOK = false
                  
                }
                <DetailsPanel
                  status={status}
                  info={info}
                  report={report}
                  frameData={frameData}
                  threshold={info?.metadata?.threshold}
                  anlystTokenOK={anlystTokenOK}
                />
              </div>
              {/* <div className="col-xs-offset-0 col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-0 col-md-3 p-b-30 flex">
                <AnalyzedFaces
                  status={status}
                  info={info}
                  report={report}
                  setVideoModal={setVideoModal}
  
                />
              </div> */}
            </div>
          </div>
          {/* <VideoModal
            faces={videoModal?.faces}
            url={videoModal?.url}
            setVideoModal={setVideoModal}
          />
          <ForensicVideoModal
            url={forensicVideoModal?.url}
            setForensicVideoModal={setForensicVideoModal}
            frameData={frameData}
            info={info} 
          /> */}
          {/* <VideoCollectionModal
            faceID={videoCollectionModal}
            setVideoModal={setVideoModal}
          /> */}
          <Footer />
        </section>
      )}
    </>
  );
};

export default ScanResult;
